import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";
import {
  CONSENT_EVENT, getMeasurementId, initGA4, isProductionHost, setRuntimeMeasurementId, trackPageView,
} from "@/analytics/ga4";

let runtimeIdPromise = null;

// Resolve the Measurement ID once per page load: build-time value if inlined,
// otherwise ask the backend (production host only — never from preview/dev).
function resolveMeasurementId() {
  if (getMeasurementId()) return Promise.resolve(getMeasurementId());
  if (process.env.NODE_ENV !== "production" || !isProductionHost(window.location.hostname)) {
    return Promise.resolve("");
  }
  if (!runtimeIdPromise) {
    runtimeIdPromise = api
      .get("/config/public")
      .then(({ data }) => setRuntimeMeasurementId(data?.ga4_measurement_id))
      .catch(() => "");
  }
  return runtimeIdPromise;
}

// Mount once inside <BrowserRouter>. GA4 initialises only after explicit
// analytics consent; sends one page_view for the current page and each route change.
export const GA4RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    let alive = true;
    const sync = () => {
      resolveMeasurementId().then(() => {
        if (!alive || !initGA4()) return;
        trackPageView({ pathname: location.pathname, search: location.search, title: document.title });
      });
    };
    sync();
    window.addEventListener(CONSENT_EVENT, sync);
    return () => {
      alive = false;
      window.removeEventListener(CONSENT_EVENT, sync);
    };
  }, [location.pathname, location.search]);

  return null;
};
